/*!
 * Copyright 2020 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { TrecApiError, TrecError } from "@trec/api/errors";
import { ErrorAction, StoreAction } from "@trec/components/store";

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace PushMsgActions {
  export class SendFCMToken extends StoreAction {
    static readonly type = "[Push Msg] Send FCM token";

    constructor(public payload: { fcmToken: string }) {
      super();
    }
  }

  export class InvalidateFCMToken extends StoreAction {
    static readonly type = "[Push Msg] Invalidate FCM token";
  }

  export class Error extends ErrorAction {
    static readonly type = "[Push Msg] Send FCM token error";
    readonly error: true = true;

    readonly errorMsgs = {
      // eslint-disable-next-line max-len
      invalid_instance_id: `Le notifiche in tempo reale potrebbero non funzionare correttamente. Per risolvere il problema, per favore, resetta i permessi sulle notifiche.`,
    };

    constructor(public payload: TrecApiError | TrecError) {
      super();
    }
  }
}
